/**
 * @module components\ghPage
 */
import Vue from "vue";
import GhBase from '../ghBase';
import {
  Component,
  Inject,
  Watch,
  Prop,
  Model,
  Emit
} from "vue-property-decorator";



@Component
export default class GhPage extends GhBase {
  @Model("update:tabIndex")
  private tabIndex!: number;

  @Prop({ default: false })
  private drawer!: boolean;

  @Prop({ default: false })
  private isMini!: boolean;

  private openDrawer = false;
  private mini = false;

  @Watch("drawer")
  private syncDrawer() {
    this.openDrawer = this.drawer;
  }

  @Watch("isMini")
  private syncMini() {
    this.mini = this.isMini;
  }

  @Watch("openDrawer")
  private updateDrawer() {
    if (this.openDrawer !== this.drawer) {
      this.$emit("update:drawer", this.openDrawer);
    }
  }

  @Watch("mini")
  private updateMini() {
    if (this.mini !== this.isMini) {
      this.$emit("update:isMini", this.mini);
    }
  }
  created() {
    this.openDrawer = this.drawer;
    this.mini = this.isMini;
  }
  mounted() {}
  activated() {
    if (this.drawer) {
      this.openDrawer = false;
      this.$nextTick(() => {
        this.openDrawer = true;
      });
    }
  }

  private returnPre() {
    if (this.tabIndex) {
      if (this.tabIndex > 0) {
        this.$emit("update:tabIndex", this.tabIndex - 1);
      }
    }
  }
}
